// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__3T3L3","btn":"style_btn__3bWuQ","btn2":"style_btn2__2KKfE"};